import i18n from "i18next";
import { CatalogPartRevisionProductFamilyVersionApi } from "src/api/generated/erp/configurator/management/catalogPart/api/catalogPartRevisionProductFamilyVersionApi.ts";
import { ConfiguratorAppVersionWarning } from "src/api/generated/erp/configurator/management/service/configuratorAppVersionWarning.ts";
import { ShowConfirmDialogFunc } from "src/components/common/dialogs/confirmDialog/ConfirmDialogContext.ts";
import { PartCreationWizardApi } from "src/api/generated/erp/parts/catalogPart/api/partCreationWizardApi.ts";

export function formatConfiguratorAppVersionWarning(warning: ConfiguratorAppVersionWarning): string {
	return i18n.t("configurator_app_version_warning", {
		appName: warning.customAppName,
		familyName: warning.productFamilyName,
		versionNumber: warning.productFamilyVersionNumber,
		inUseVersionNumber: warning.inUseProductFamilyVersionNumber,
		propertyNames: warning.propertyNames.join(", "),
	});
}

/**
 * Asks to confirm when published catalog part revisions would start to use a product family version with required
 * inputs that the family's configurator Custom App has not had to set. Resolves true when there is nothing to confirm.
 */
export async function confirmConfiguratorAppVersionWarning(
	showConfirm: ShowConfirmDialogFunc,
	productFamilyVersionId: number,
): Promise<boolean> {
	const warning = await CatalogPartRevisionProductFamilyVersionApi.getConfiguratorAppVersionWarning({
		productFamilyVersionId,
	});
	return await confirmWarning(showConfirm, warning);
}

/** Asks to confirm publishing the first catalog part revision of a new part in the product family; see above. */
export async function confirmConfiguratorAppVersionWarningForNewCatalogPart(
	showConfirm: ShowConfirmDialogFunc,
	configurationProductFamilyId: number,
): Promise<boolean> {
	const warning = await PartCreationWizardApi.getConfiguratorAppVersionWarning({ configurationProductFamilyId });
	return await confirmWarning(showConfirm, warning);
}

async function confirmWarning(
	showConfirm: ShowConfirmDialogFunc,
	warning: ConfiguratorAppVersionWarning | null,
): Promise<boolean> {
	if (warning == null) return true;
	return await showConfirm({
		title: i18n.t("configurator_app"),
		message: formatConfiguratorAppVersionWarning(warning),
	});
}
